"use client"

import IconArrowLeft from "@/app/(site)/_components/Atoms/Icons/IconArrowLeft"
import { getLangCode } from "@/app/(site)/_utils/misc"
import { t } from "@/translations"
import Logo from "@assets/LogoBlack.svg"
import Image from "next/image"
import { usePathname } from "next/navigation"
import Text from "../../../Atoms/Text"
import DynamicLink from "../../../Molecules/Link"
export default function CheckoutHeader() {
    const langCode = getLangCode(usePathname().split("/")[1]) ?? ""
    return (
        <div className="flex justify-between">
            <DynamicLink
                href={"/"}
                className="flex items-center gap-10 p-16 md:p-24"
                prefetch={false}
            >
                <IconArrowLeft className="h-16 w-16" />
                <Text size="medium" weight="regular">
                    {t(langCode, "checkout.return_to_shop")}
                </Text>
            </DynamicLink>
            <div className="p-24">
                <DynamicLink href={"/"} className="cursor-pointer" prefetch={false}>
                    <Image
                        src={Logo.src}
                        alt="poc sports logo"
                        width={89}
                        height={30}
                        className="h-24 w-75 md:h-30 md:w-89"
                        unoptimized={true}
                    />
                </DynamicLink>
            </div>
        </div>
    )
}
